import { Box, useTheme } from "@mui/material";
import React from "react";
import UrlTile from "./UrlTile/UrlTile";
import { ClockIcon, CubeIcon } from "../../../../../../components/Icons";

interface IUrlsProps {
  ordersUrl?: string;
  subscriptionsUrl?: string;
  shopUrl: string;
}

const Urls = ({ ordersUrl, subscriptionsUrl, shopUrl }: IUrlsProps) => {
  const theme = useTheme();

  return (
    <Box
      className="flex w-full"
      sx={{
        flexDirection: { xs: "column", md: "row" },
        gap: { xs: 2, md: 5 },
      }}
    >
      <UrlTile
        title="Total Orders"
        description="Track your GoodVets Online Pharmacy orders and easily reorder when needed."
        url={ordersUrl}
        shopUrl={shopUrl}
        icon={<CubeIcon />}
        iconBgColor={theme.palette.green.lighter}
      />
      <UrlTile
        title="Auto-shipped Items"
        description="Manage your automatic pharmacy deliveries to keep your pet's care on track."
        url={subscriptionsUrl}
        shopUrl={shopUrl}
        icon={<ClockIcon color={theme.palette.warning.dark} />}
        iconBgColor={theme.palette.primary.light}
      />
    </Box>
  );
};

export default Urls;
